app.controller("EmployeeViewDocumentController", [
    "$scope", "DocumentsService", "$uibModal", "$stateParams", "AuthService", "Socket", "StaticData", "$state", "toastr", "usSpinnerService", "$rootScope",
    function ($scope, DocumentsService, $uibModal, $stateParams, AuthService, Socket, StaticData, $state, toastr, usSpinnerService, $rootScope) {
        var documentId = $stateParams.documentId;
        usSpinnerService.stop('root');
        $scope.format = "dd-MM-yyyy HH:mm:ss";
        $scope.actionType = $stateParams.actionType;
        $scope.infoId = $stateParams.infoId;
        $scope.deadLine = new Date();
        $scope.createDate = null;
        $scope.isRoot = null;
        $scope.ready = null;
        $scope.myInfo = {};
        $scope.doc = null;
        $scope.addressees = [];
        $scope.addressTree = [];
        $scope.attachments = [];
        $scope.readyToShow = false;
        $scope.showChancelleryButtons = false;
        $scope.showActionButtons = false;
        $scope.hasActions = false;  // აქვს თუ არა მომზადებულ ცნობაზე ქმედების უფლება
        $scope.basisDocs = [];
        $scope.returnUrl = $stateParams.returnUrl;
        $scope.externalFileUrl;
        var socket = new Socket("/documents");

        var list_to_tree = function (list) {
            var map = {}, node, roots = [], i;
            for (i = 0; i < list.length; i += 1) {
                map[list[i]._id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }

            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.resolvedBy && node.resolvedBy._id) {
                    list[map[node.resolvedBy._id]].children.push(node);
                } else {
                    roots.push(node);
                }
            }

            return roots;
        };

        socket.on('statusChange', function (resultDocumentId) {
            if (resultDocumentId !== documentId) return;
            $scope.ready = false;
            fetchOne(documentId);
        });

        if ($stateParams.actionType === 'inbox' && $stateParams.status === 'unread') {
            usSpinnerService.spin('root');
            DocumentsService.markWithStatus({
                documentId: documentId,
                status: 'read'
            }).then(function () {
                fetchOne(documentId);
                $rootScope.documentsCount();
                usSpinnerService.stop('root');
            });
        } else {
            fetchOne(documentId);
        }

        function fetchOne() {
            usSpinnerService.spin('root');
            DocumentsService.fetchOne(documentId).then(function (doc) {
                $scope.doc = doc;
                $scope.attachments = doc.attachments;
                $scope.addressees = doc.infos;
                $scope.type = doc.type;
                $scope.text = doc.text;
                $scope.createDate = doc.createDate;
                $scope.readyToShow = true;
                $scope.addressTree = list_to_tree($scope.addressees);
                $scope.getMyInfoStatus();
                $scope.isRoot = AuthService.isRoot;
                if(doc.type.parentId === "STUDENT_INNER") {
                    DocumentsService.getActions(documentId).then(function (actions) {
                        $scope.actions = actions.data;
                    })
                }

                $scope.getFileUrl(doc);

                if (doc.basisFiles && doc.basisFiles.length) {
                    $scope.basisDocs = $scope.basisDocs.concat(doc.basisFiles);
                }
                if (doc.basisDocs && doc.basisDocs.length) {
                    $scope.basisDocs = $scope.basisDocs.concat(doc.basisDocs);
                    if(doc.basisDocs[0].resolvers.length){
                        $scope.hasActions = !!AuthService.user.profiles.find(profile => {
                            return profile._id === doc.basisDocs[0].resolvers[0]._id} )
                    }
                }

                if (doc.resolvers && doc.resolvers.length) {
                    if (doc.resolvers && doc.resolvers.length) {
                        for (var i in doc.resolvers) {
                            if (doc.workerId === doc.resolvers[i]._id) {
                                $scope.ready = false;
                            }
                        }
                    } else {
                        $scope.ready = true;
                    }
                }
                $scope.ready = true;
                $scope.generateButtons();
                usSpinnerService.stop('root');
            });
        }

        $scope.generateButtons = function () {
            if ($scope.doc.status === 'done') return;
            if ($scope.actionType === 'review' && !$scope.doc.chancelleryStatus && $scope.readyToShow) {
                $scope.showChancelleryButtons = true;
            } else if ($scope.actionType === 'inbox') {
                // if ($scope.doc.isForStudent && $scope.doc.chancelleryStatus !== 'returned') {
                //     if (!$scope.doc.infos.length) {
                //         $scope.showActionButtons = true;
                //     } else {
                //         if ($scope.doc.status == 'done') return;
                //         for (var i in $scope.doc.infos) {
                //             if ($scope.doc.workerId == $scope.doc.infos[i].addressee._id) {
                //                 $scope.showActionButtons = true;
                //             }
                //         }
                //     }
                // } else
                if ($scope.actionType === 'inbox' && $scope.doc.chancelleryStatus === 'approved') {

                    if ($scope.myInfo && ($scope.myInfo.status === 'unread' || $scope.myInfo.status === 'read')) {
                        $scope.showActionButtons = true;
                    }
                }

            }
        };

        $scope.changeChancelleryStatus = function (status, comment) {
            if ($scope.doc.isForStudent) statusChange(documentId, status, comment.comment, null)
            else {
                $uibModal.open({
                    controller: "CommentWindowController",
                    templateUrl: _pb + 'employee/documents/comment-window.html',
                    size: "md",
                    backdrop: 'static',
                    resolve: {
                        params: function () {
                            return {
                                text: null,
                                action: 'setTopic',
                                isForStudent: $scope.doc.isForStudent
                            };
                        }
                    }
                }).result
                    .then(function (data) {
                        usSpinnerService.spin('root');
                        statusChange(documentId, status, comment.comment, data.comment)
                    }, function () {

                    });
            }

            function statusChange(documentId, status, comment, topic) {
                DocumentsService.setChancelleryStatus({
                    documentId: documentId,
                    status: status,
                    comment: comment,
                    topic: topic

                }).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.documentsCount();
                        usSpinnerService.stop('root');
                        if (status === 'approved') toastr.success('', 'დოკუმენტი დაშვებულია');
                        else toastr.success('', 'დოკუმენტი დაბლოკილია');
                        if ($scope.doc.isForStudent) $state.go('employee.documents.student');
                        else $state.go('employee.documents.review');
                    } else toastr.error('', 'სტატუსის ცვლილებისას დაფიქსირდა შეცდომა');
                });
            }

        };

        $scope.apply = function () {
            $scope.changeChancelleryStatus('approved', '')
        };

        $scope.block = function () {
            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: null,
                            action: 'create',
                            isForStudent: $scope.doc.isForStudent
                        };
                    }
                }
            }).result
                .then(function (comment) {
                    $scope.changeChancelleryStatus('returned', comment)
                }, function () {

                });
        };

        $scope.setAddresseeStatus = function (status, data) {
            usSpinnerService.spin('root');

            DocumentsService.setAddresseeStatus({
                documentId: documentId,
                status: status,
                comment: data && data.comment ? data.comment.value : null,
                actionCommentIsForStudent: data ? data.actionCommentIsForStudent : null,
            }).then(function () {
                if (status === 'returned') toastr.success('', 'დოკუმენტი მიბრუნებულია');
                if (status === 'done') toastr.success('', 'დოკუმენტი შესრულებულია');
                usSpinnerService.stop('root');
                history.replaceState(null, null, $stateParams.returnUrl);
            })
        };

        $scope.getMyInfoStatus = function () {
            for (var i in $scope.addressees) {
                if ($scope.addressees[i]._id === $scope.infoId) {
                    $scope.myInfo = $scope.addressees[i]
                }
            }
        };

        $scope.resolution = function () {
            $state.go('employee.documents.new', { documentId: documentId, action: 'resolve', returnUrl: $stateParams.returnUrl })
        };

        $scope.done = function () {
            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: null,
                            action: 'create',
                            isForStudent: $scope.doc.isForStudent
                        };
                    }
                }
            }).result
                .then(function (data) {
                    $scope.setAddresseeStatus('done', data)
                }, function () {

                });
        };

        $scope.return = function () {
            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: null,
                            action: 'create',
                            isForStudent: $scope.doc.isForStudent
                        };
                    }
                }
            }).result
                .then(function (data) {
                    $scope.setAddresseeStatus('returned', data)
                }, function () {

                });
        };

        $scope.saveAsDraft = function () {
            DocumentsService.send({
                type: $scope.type,
                text: $scope.text,
                status: 'draft',
                addressees: $scope.addressees,
                attachments: $scope.attachments
            }).then(function () {
                toastr.success('', 'მონახაზი შენახულია');
                $rootScope.documentsCount();
                $state.go('employee.documents.draft')
            }).catch(function () {
                toastr.error('', 'მონახაზის შენახვისას დაფიქსირდა შეცდომა');
            })
        };

        $scope.showComment = function (header, text, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: text,
                            header: header,
                            action: 'view'
                        };
                    }
                }
            })
        };

        $scope.createBasedDocument = function () {
            $state.go('employee.documents.new', { basis: $scope.doc.uniqueNumber, documentId: documentId })
        };

        $scope.createBasedOutgoingDocument = function () {
            $state.go('employee.documents.new-response', { basisDocNumber: $scope.doc.uniqueNumber })
        };

        $scope.openBasis = function (basis, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "ViewDocumentWindowController",
                templateUrl: _pb + 'employee/documents/view-document-window.html',
                size: "lg",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            document: basis,
                            action: 'view'
                        };
                    }
                }
            })
        };

        $scope.print = function (withBlank = false) {
            let url = 'documents/export/' + documentId;
            if (withBlank)
                url +='?withBlank=true';
            window.open(url);
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.generateClass = function (status) {
            if (!status || status === 'unread') return 'doc-unread';
            if (status === 'approved') return 'doc-approved';
            if (status === 'read') return 'doc-read';
            if (status === 'returned') return 'doc-returned';
        };

        $scope.generateTooltip = function (status) {
            if (!status || status === 'unread') return 'წაუკითხავი';
            if (status === 'approved') return 'შესრულებული';
            if (status === 'read') return 'წაკითხული';
            if (status === 'returned') return 'მობრუნებული';
        };

        $scope.getFileUrl = function (doc) {
            if (doc.documentFile) {
                const fileName = doc.documentFile && doc.documentFile.name ? doc.documentFile.name.replaceAll(" ", "-") : "File.pdf";
                $scope.externalFileUrl = `${window.location.origin}/file/remote/${fileName}/?url=${doc.documentFile.location}`;
            }
        };

        $scope.getSender = function (doc) {
            if (!doc) return "";
            if (doc.author && doc.author.user) {
                return doc.author.user.firstName + " " + doc.author.user.lastName;
            }
            else return doc.senders.map(function (sender) { return sender.name + ' - (' + sender.id + ')'; }).toString()
        };

        $scope.downloadDocumentZip = function () {
            window.open(window.location.origin + "/documents/zip/download/?documentId=" + $scope.doc._id)
        }

        $scope.printCheck = function () {
            window.open('documents/external/check/' + $scope.doc._id);
        }

        $scope.getOutgoingAddresses = function() {
            return (((($scope.doc.features || {}).baseType || {}).OUTGOING || {}).addressees || [])
        }

        $scope.review = function (action) {
            DocumentsService.review({documentId, action}).then(function () {
                if(action === 'reject') {
                    toastr.success('', 'დოკუმენტი უარყოფილია');
                } else {
                    toastr.success('', 'დოკუმენტი შესრულებულია');
                }
                fetchOne(documentId);
                history.replaceState(null, null, $stateParams.returnUrl)
            }).catch(function () {
                toastr.error('', 'დაფიქსირდა შეცდომა');
            })
        }
    }

]);
